import { render, staticRenderFns } from "./VMuPicker.vue?vue&type=template&id=63da246a&scoped=true&"
import script from "./VMuPicker.vue?vue&type=script&lang=js&"
export * from "./VMuPicker.vue?vue&type=script&lang=js&"
import style0 from "./VMuPicker.vue?vue&type=style&index=0&id=63da246a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63da246a",
  null
  
)

export default component.exports